import * as React from 'react';
const SvgSortUp = (props) => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M5.002 18.499h13.993c2.664 0 4.016-3.236 2.117-5.119l-6.993-7a2.998 2.998 0 0 0-4.242 0l-7 7C1.002 15.261 2.33 18.5 5.002 18.5ZM12 8.498l7 7H5.002l6.998-7Z", fill: "currentColor" })));
export default SvgSortUp;
